import React from 'react';
import { motion } from 'framer-motion';
import { Phone, ChevronDown } from 'lucide-react';
export function HeroSection() {
  return <section id="hero" className="relative min-h-[90vh] flex items-center justify-center overflow-hidden" data-id="element-187">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/cF6EfctbLV48srjbqNP6VB/new.png")'
    }} data-id="element-188">
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-[#1B2E1B]/70" data-id="element-189" />
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center pt-40 pb-12" data-id="element-190">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-white tracking-tight mb-6 leading-tight" data-id="element-191">
          The Lawn Your Home Deserves <br className="hidden md:block" data-id="element-192" />
          <span className="text-[#C5A55A]" data-id="element-193">Without Lifting a Finger</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-lg md:text-2xl text-gray-200 mb-10 max-w-3xl font-light" data-id="element-194">
          Professional lawn care that turns heads and raises your curb appeal.
          Free quotes in under 10 minutes.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-195">
          <a href="tel:8325034445" className="flex items-center justify-center gap-2 bg-[#2D5A27] hover:bg-[#1B2E1B] text-white px-8 py-4 rounded-lg font-bold text-lg transition-all duration-300 shadow-[0_0_20px_rgba(45,90,39,0.4)] hover:shadow-[0_0_25px_rgba(45,90,39,0.6)] hover:-translate-y-1" data-id="element-196">
            <Phone className="w-6 h-6" data-id="element-197" />
            Call Now: 832-503-4445
          </a>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.2,
      duration: 1
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center text-white/50" data-id="element-198">
        <span className="text-sm mb-2 uppercase tracking-widest" data-id="element-199">
          Discover How
        </span>
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }} data-id="element-200">
          <ChevronDown className="w-6 h-6" data-id="element-201" />
        </motion.div>
      </motion.div>
    </section>;
}